import React, { FC, useContext, useState } from "react";
import styled from "styled-components";

import Back from "../components/common/Back";
import Button from "../components/common/Button";
import MaxWidth from "../components/styles/max-width";
import ReviewForm from "../components/forms/ReviewForm";
import AsideModal from "../components/reviews/AsideModal";
import HelmetComponent from "../components/layout/HelmetComponent";
import ReviewsListVirtual from "../components/reviews/ReviewsListVirtual";

import { CityContext } from "../components/context/CityContext";

const Reviews: FC<{}> = () => {
  const { cityNameForSeo } = useContext(CityContext);
  const [open, setOpen] = useState(false);

  return (
    <Wrapper>
      <MaxWidth>
        <AsideModal open={open} setOpen={setOpen}>
          <Main>
            <HelmetComponent
              title={`МИКАfood - Отзывы - Доставка еды в ${cityNameForSeo}`}
              description="Будем благодарны вам за оценку качества нашей еды и сервиса. Мы внимательно относимся к отзывам и пожеланиям наших посетителей и стараемся быстро реагировать на них."
            />
            <Back name="НА ГЛАВНУЮ" href="/" />
            <h1>Отзывы</h1>
            <p>
              Для нас важен каждый отзыв. Будем благодарны вам за оценку
              качества еды и сервиса в наших пиццериях и от службы доставки.
            </p>
            <ModalButton
              primary
              big
              full
              onClick={() => {
                setOpen(true);
              }}
            >
              ОСТАВИТЬ ОТЗЫВ
            </ModalButton>
            <ReviewsListVirtual />
          </Main>
          <ReviewForm />
        </AsideModal>
      </MaxWidth>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  overflow: hidden;
`;

const Main = styled.div``;

const ModalButton = styled(Button)`
  margin: 20px 0 10px;
  max-width: 333px;

  @media (max-width: 675px) {
    margin: 1rem auto;
  }

  @media (min-width: 1301px) {
    display: none;
  }
`;

export default Reviews;
